import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { checkEmail } from '@/utils/validate';
function validateEmail(rules, value, callback) {
  if (value && !checkEmail(value)) {
    callback(new Error(this.$t('邮箱格式有误，请重新填写')));
  }
  callback();
}
export function generateValidateRule(control, formData) {
  const rules = [];
  if (control.attributeVerification === 'PHONE') {
    rules.push({
      pattern: /^1[0-9]{10}$/,
      message: '请输入有效的手机号码',
      trigger: 'blur'
    });
  }
  if (control.attributeVerification === 'IDCODE') {
    rules.push({
      pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '请输入有效的身份证号码',
      trigger: 'blur'
    });
  }
  const validateEnclosure = (rule, value, callback) => {
    // console.log('validateEnclosure', control.fileListData);
    let files = formData[control.mark];
    if (!files || files.length === 0) {
      callback(new Error(this.$t('请上传附件')));
    } else {
      callback();
    }
  };
  if (control.attributeVerification === 'email') {
    // rules.push({
    //   validator: validateEmail,
    //   message: '请输入有效的邮箱地址',
    //   trigger: 'blur'
    // });
  }
  if (control.attributeVerification === 'NUMBER') {
    var _this$formData$contro, _String;
    rules.push({
      pattern: /^\d+(\.\d+)?$/,
      message: '请输入数字',
      trigger: 'blur'
    });
    console.log(this.formData[control.mark], control.mark, '--------mark------');
    // 校验小数点
    let decimalPlaces = (_this$formData$contro = this.formData[control.mark]) === null || _this$formData$contro === void 0 ? void 0 : _this$formData$contro.split('.')[1];
    let len = (_String = String(decimalPlaces)) === null || _String === void 0 ? void 0 : _String.split('').length;
    if (len > control.decimalPlaces) {
      rules.push({
        min: parseInt(0),
        max: parseInt(control.decimalPlaces),
        message: `最多只能输入带有${control.decimalPlaces}位小数的数值`,
        trigger: 'blur'
      });
    }
  }
  // 是否必填校验
  if (control.isRequired) {
    if (control.partsType === 'singleChoice' || control.partsType === 'multipleChoice' || control.partsType === 'date') {
      rules.push({
        required: true,
        message: `请选择${control.controlName}`,
        trigger: 'blur'
      });
    } else if (control.partsType === 'enclosure') {
      rules.push({
        required: true,
        validator: validateEnclosure,
        trigger: 'blur'
      });
    } else {
      rules.push({
        required: true,
        message: `请输入${control.controlName}`,
        trigger: 'blur'
      });
    }
  }
  if (control.numberLimit) {
    // console.log('-----limit------', control.value.length);
    const [min, max] = control.numberLimit.split(',');
    if (control.partsType === 'multipleChoice') {
      if (control.value.length > parseInt(max)) {
        rules.push({
          min: parseInt(min),
          max: parseInt(max),
          message: `最多只能选择${max}个${control.controlName}`,
          trigger: 'blur'
        });
      } else if (control.value.length < parseInt(min)) {
        rules.push({
          min: parseInt(min),
          max: parseInt(max),
          message: `最少也要选择${min}个${control.controlName}`,
          trigger: 'blur'
        });
      }
    } else {
      rules.push({
        min: parseInt(min),
        max: parseInt(max),
        message: `长度在${min}到${max}个字符`,
        trigger: 'blur'
      });
    }
  }
  if (control.dateType) {}
  return rules;
}